// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getStoreListApi } from "../../Service/Api/StoreListApi"
import { getStore, getStoreList,getErrors } from "../Reducer/StoreListReducer"



// Watchers
function* storeListSaga() {
	yield takeEvery("storeList/getStoreList", getStores)
}

// Sagas
function* getStores(action) {

	try {
		const storeList = yield call(getStoreListApi, action.payload)
		
		if (storeList.request.status === 200) {
            // console.log(storeList);
			yield put(getStore(storeList))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
        // console.log(error);
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(storeListSaga)])
}
